import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const AnimatedNumber = ({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [displayValue, setDisplayValue] = useState(0);
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000;
      const increment = value / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setDisplayValue(value);
          clearInterval(timer);
        } else {
          setDisplayValue(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} data-id="element-358">
      {displayValue.toLocaleString()}
      {suffix}
    </span>;
};
export function Stats() {
  const stats = [{
    value: 12000,
    suffix: '+',
    label: 'Reviews Generated'
  }, {
    value: 3.2,
    suffix: 'x',
    label: 'Avg Call Increase',
    isFloat: true
  }, {
    value: 1,
    suffix: '',
    label: '#1 Map Pack Rankings',
    prefix: '#'
  }, {
    value: 98,
    suffix: '%',
    label: 'Client Retention'
  }];
  return <section className="bg-navy py-16 relative overflow-hidden" data-id="element-359">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-360">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" data-id="element-361">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-362">
              <div className="text-4xl md:text-5xl font-heading font-extrabold text-gold mb-2" data-id="element-363">
                {stat.prefix}
                {stat.isFloat ? <AnimatedNumberFloat value={stat.value} suffix={stat.suffix} data-id="element-364" /> : <AnimatedNumber value={stat.value} suffix={stat.suffix} data-id="element-365" />}
              </div>
              <div className="text-sm md:text-base font-medium text-white/90" data-id="element-366">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
// Separate component for float to handle decimals
const AnimatedNumberFloat = ({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  const [displayValue, setDisplayValue] = useState(0);
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000;
      const increment = value / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setDisplayValue(value);
          clearInterval(timer);
        } else {
          setDisplayValue(Number(start.toFixed(1)));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} data-id="element-367">
      {displayValue.toFixed(1)}
      {suffix}
    </span>;
};